import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useScreenContext, Option } from "../Layout";

function Time() {
  const { t } = useTranslation();
  const [screenData, setScreenData] = useScreenContext();

  useEffect(() => {
    setScreenData(() => ({
      ...screenData,
      submitLabel: t("layout.cta_continue"),
      nextPath: "reading-stats",
      progress: 35,
    }));
  }, []);

  const handleOptionSelection = (option: string) => {
    console.log(option);
    setScreenData(() => ({
      ...screenData,
      userPreferences: {
        ...screenData.userPreferences,
        time: option,
      },
    }));
  };

  return (
    <div>
      <h1 className="mb-4 text-2xl font-bold tracking-tight text-gray-900 dark:text-white md:text-5xl">
        {t("time.headline")}
      </h1>
      <div className="mt-10">
        <Option onClick={() => handleOptionSelection("15min")}>
          {t("time.option_1")}
        </Option>
        <Option onClick={() => handleOptionSelection("15-30min")}>
          {t("time.option_2")}
        </Option>
        <Option onClick={() => handleOptionSelection("30min+")}>
          {t("time.option_3")}
        </Option>
      </div>
    </div>
  );
}

export default Time;
